import Knock from "@knocklabs/client";
import configService from "../services/config";

let knockInstance = null;

export function getKnock() {
  if (knockInstance) return knockInstance;
  const apiKey = configService.get("knockApiKey");
  if (!apiKey) {
    console.warn("Knock API key not found in runtime config (knockApiKey)");
    return null;
  }
  knockInstance = new Knock(apiKey);
  return knockInstance;
}

export const knock = /** @deprecated use getKnock() instead */ getKnock();
